import { getDurationSettingKey } from 'FRONTEND/utils/stringFormatting';

export const THEME_APP_NAME = 'cloud'; // Key to get the right theme from the frontend_library

export const SNACKBAR_AUTOHIDE_DURATION = 6000;
export const SNACKBAR_CREATION_AUTOHIDE_DURATION = 20000;

export const MIN_APPOINTMENT_DISPLAY_DURATION = 15;
export const MAX_APPOINTMENT_DURATION = 120;
export const APPOINTMENT_DURATION_STEP = 5;
export const APPOINTMENT_DEFAULT_DURATION = 20;
// Temporary change the default appointment duration
// See https://tracker.parsys.com/parsys/parsys_cloud/-/issues/1807#top
// export const LOCATION_APPOINTMENT_DEFAULT_DURATION = 30;
export const LOCATION_APPOINTMENT_DEFAULT_DURATION = 15;
export const DURATION_LIST = [];
for (let duration = APPOINTMENT_DURATION_STEP; duration <= MAX_APPOINTMENT_DURATION; duration += APPOINTMENT_DURATION_STEP) {
  DURATION_LIST.push(duration);
}
export const SLOT_STATUS_FREE = 'free';
export const APPOINTMENT_STATUS_PENDING = 'pending';
export const APPOINTMENT_STATUS_PROPOSED = 'proposed';
export const APPOINTMENT_STATUS_PENDING_OR_PROPOSED = 'pending_or_proposed';
export const APPOINTMENT_STATUS_BOOKED = 'booked';
export const APPOINTMENT_STATUS_AWAITING_PAYMENT = 'awaiting_payment';
export const APPOINTMENT_STATUS_AWAITING_CAPTURE = 'awaiting_capture';
export const APPOINTMENT_STATUS_CANCELLED = 'cancelled';
export const APPOINTMENT_STATUS_FILTER_LIST = [
  APPOINTMENT_STATUS_AWAITING_PAYMENT,
  APPOINTMENT_STATUS_AWAITING_CAPTURE,
  APPOINTMENT_STATUS_BOOKED,
  APPOINTMENT_STATUS_PENDING_OR_PROPOSED,
  APPOINTMENT_STATUS_CANCELLED,
];

export const PARTICIPANT_STATUS_NEEDS_ACTION = 'needs_action';
export const PARTICIPANT_STATUS_ACCEPTED = 'accepted';
export const PARTICIPANT_STATUS_TENTATIVE = 'tentative';
export const PARTICIPANT_STATUS_DECLINED = 'declined';

export const AVAILABILITY_KIND = 'availability';
export const APPOINTMENT_KIND = 'appointment';
export const EVENT_KIND_LIST = [
  AVAILABILITY_KIND,
  APPOINTMENT_KIND,
];

export const EXPERT = 'expert';
export const RESOURCE = 'resource';

export const VIDEO_CONSULTATION = 'teleconsultation';
export const VIDEO_SPECIALIST_ASSESSMENT = 'telestaff';
export const OTHER = 'other_appointment';
export const BOOTH_TELECONSULTATION = 'booth_teleconsultation';

export const APPOINTMENT_TYPE_LIST = [
  VIDEO_CONSULTATION,
  VIDEO_SPECIALIST_ASSESSMENT,
  OTHER,
];
export const BOOKABLE_APPOINTMENT_TYPE_LIST = [
  VIDEO_CONSULTATION,
  VIDEO_SPECIALIST_ASSESSMENT,
  OTHER,
];

export const BOOKABLE_PATIENT_APPOINTMENT_TYPE_LIST = [
  VIDEO_CONSULTATION,
  BOOTH_TELECONSULTATION,
];

export const RESOURCE_APPOINTMENT_TYPE_LIST = [
  VIDEO_CONSULTATION,
];

export const DEFAULT_SETTINGS = {
  [getDurationSettingKey(VIDEO_SPECIALIST_ASSESSMENT)]: APPOINTMENT_DEFAULT_DURATION,
  [getDurationSettingKey(VIDEO_CONSULTATION)]: APPOINTMENT_DEFAULT_DURATION,
  [getDurationSettingKey(OTHER)]: APPOINTMENT_DEFAULT_DURATION,
};

export const DRAFT_AVAILABILITY_ID = 'draft';

export const FormTypes = {
  GIVEN_SLOT_FORM: 'given_slot_form',
  GIVEN_EXPERT_FORM: 'given_expert_form',
  LOCATION_FORM: 'location_form',
  UNRESTRICTED_FORM: 'unrestricted_form',
  PATIENT_FORM: 'patient_form',
};

export const MAX_CHECKED_EXPERT_COUNT = 5;

export const MAX_LOADING_TIME = 60000;

export const PATIENT_MINIMUM_SEARCH_CHARACTERS = 3;
export const EXPERT_MINIMUM_SEARCH_CHARACTERS = 3;
export const CALENDAR_MINIMUM_ITEMS_TO_SHOW_SEARCH = 10;

export const STETHOSCOPE = {
  BODY_CHEST: 'C',
  BODY_CHEST_LEFT: 'CL',
  BODY_CHEST_RIGHT: 'CR',
  BODY_BACK: 'B',
  BODY_BACK_LEFT: 'BL',
  BODY_BACK_RIGHT: 'BR',
  BODY_ABDOMEN: 'A',
  BODY_ABDOMEN_LEFT: 'AL',
  BODY_ABDOMEN_RIGHT: 'AR',
};

export const UPLOAD_TOLERANCE = 2000; // ms
export const PROGRESS_ESTIMATE_DELAY = 10; // sec

export const MAX_SEARCH_RESULT_NUMBER = 15;

export const CREATE_ERROR = 'create_error';
export const LIST_ERROR = 'list_error';
export const UPDATE_ERROR = 'update_error';
export const DELETE_ERROR = 'delete_error';


export const LOCAL_STORAGE_LAST_WORKFLOW_KEY = 'last_workflow';
export const LOCAL_STORAGE_WORKFLOW_CACHE_VERSION_KEY = 'last_workflow_cache_version';
// Bump this integer whenever you introduce changes that make previously cached workflows incompatible.
// This may happen if we change the formatWorkflow function in the frontend_library,
// or if we change the stored workflow format in a way that is not backward compatible.
// On the next page load the stale cache will be wiped automatically.
export const WORKFLOW_CACHE_NUMBER = 1;

export const DRAFT_STATUS = 'draft';

export const surveillanceDataColor = {
  SYS: '#FFC300',
  DIA: '#F85200',
  MAP: '#764B35',
  glasgowScore: '#74736D',
  heartRate: '#A751B6',
  SPO2: '#1A2CD8',
  oxygen: '#55C7E9',
  ETCO2: '#FFC300',
  respiratoryFrequency: '#4DD73D',
  glucose: '#FF0000',
  temperature: '#FF00DF',
  EVA: '#74736D',
  SaO2: '#55C7E9',
  SpCO: '#55C7E9',
};

export const formColors = {
  inputBorder: '#66afe9',
  inputBorderLight: '#1269cf4d',
  selectedItem: '#1976d2',
  selectedItemLight: '#1976d221',
  white: '#fff',
  lightGrey: '#ccc',
  inputBoxShadow: 'rgba(102, 175, 233, 0.6)',
};


export const SURVEILLANCE_EXAM_NAME = {
  VITALS: 'vitals',
  ACTS: 'acts',
  MEDICINE: 'medicine',
  MEDICAL_EVOLUTION: 'medical_evolution',
  SCORES: 'scores',
  MULTIPARAMETRIC_DATA: 'MULTIPARAMETRIC_DATA',
};

// Custom JS events
export const CUSTOM_EVENTS = {
  FIELD_UPDATED: 'fieldUpdated', // used manually when 'input' event doesn't automatically catch certain field changes.
};

export const BOOTH_TOGGLE_OPTIONS = [
  { value: false, key: VIDEO_CONSULTATION },
  { value: true, key: BOOTH_TELECONSULTATION },
];

export const AppointmentScenarios = {
  CLASSIC_TELECONSULTATION: 'classic-teleconsultation',
  ASSISTED_TELECONSULTATION: 'assisted-teleconsultation',
  DELEGATED_CONSULTATION: 'delegated-consultation',
  BOOTH_TELECONSULTATION: 'booth-teleconsultation',
  PATIENT_PORTAL_TELECONSULTATION: 'patient-portal-teleconsultation',
  PATIENT_PORTAL_BOOTH_TELECONSULTATION: 'patient-portal-booth-teleconsultation',
  CLASSIC_TELESTAFF: 'classic-telestaff',
  DELEGATED_TELESTAFF: 'delegated-telestaff',
  IN_PERSON_CONSULTATION: 'in-person-consultation',
};
export const EXAM_ICON_NAMES = [
  'interview',
  'ecg',
  'spiro',
  'nibp',
  'heart_rate',
  'oximetry',
  'temperature',
  'glucose',
  'respiratory_rate',
  'photo',
  'video',
  'attachments',
];

export const REMINDER_COLORS = {
  0: null,
  1: '#FF0000',
  2: '#FFA500',
  3: '#00FF00',
  4: '#0000FF',
  5: '#800080',
  6: '#000000',
};
